import { InvalidCredentialsError } from "../../../domain/errors/invalid-credentials-error";
import { UnexpectedError } from "../../../domain/errors/unexpected-error";
import { HttpClient, HttpStatusCode } from "../../protocols/http/http-client";

export class RemoteAdminFiscalNote {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient,
  ) {}

  async getPlugNotasJson(fiscalNoteId: number): Promise<object | null> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${fiscalNoteId}/plugnotas-json`,
      method: "get",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        if (typeof httpResponse.body === "string") {
          return JSON.parse(httpResponse.body);
        }
        return httpResponse.body;
      case HttpStatusCode.noContent:
        return null;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.forbidden:
        throw new Error("Acesso negado");
      case HttpStatusCode.notFound:
        throw new Error("Nota fiscal não encontrada");
      default:
        throw new UnexpectedError();
    }
  }
}
